export default firstEligibleDiscountMessage = (discountMessages) => {
  if (!discountMessages) return null;

  return discountMessages.find((discountMessage) => {
    const matchesGroup = discountMessage?.customerGroups.includes(
      window.theme.customer_group,
    );
    const markets = JSON.parse(discountMessage?.markets || "[]");
    const matchesMarket = markets.includes(window.theme.country);

    return matchesGroup && matchesMarket;
  });
};
